import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 11.25C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75C18.4096 12.75 5.59042 12.75 20 12.75C20.4142 12.75 20.75 12.4142 20.75 12C20.75 11.5858 20.4142 11.25 20 11.25C5.59042 11.25 18.4096 11.25 4 11.25Z",
		fill: "currentColor"
	})
});
export { SvgIconRemove as ReactComponent };
